import React, { useEffect, useState } from "react";
// import './PackagesStyles.css'
import { LocalStorageServices } from "../../../../services/localStorageServices";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomTable from "../../../../components/custom_table/CustomTable";
import { PiEye } from "react-icons/pi";
import { BiEditAlt } from "react-icons/bi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { ErrorToast, InfoToast, SuccessToast } from "../../../../toast/toasts";
import CustomBottomPagination from "../../../../components/custom_bottom_pagination/CustomBottomPagination";
import { IconButton, Tooltip } from "@mui/material";
import { IoCloseCircleOutline } from "react-icons/io5";
import { TiTickOutline } from "react-icons/ti";
import { FaRegCirclePause } from "react-icons/fa6";
import { SiTicktick } from "react-icons/si";
import { FaRegCommentAlt } from "react-icons/fa";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { PiFilesLight } from "react-icons/pi";
import { useSelector } from "react-redux";
import CustomDeleteConfirmModal from "../../../../components/custom_delete_confirm_modal/CustomDeleteConfirmModal";
import VisaCommentModal from "./visa_comment_modal/VisaCommentModal";
import VisaReusableModal from "./visa_reusable_modals/VisaReusableModal";
import VisaInvoiceDetailsModal from "./visa_invoice_details_modal/VisaInvoiceDetailsModal";
import VisaFinanceLevelModals from "./visa_finance_level_modals/VisaFinanceLevelModals";
import {
  delete_Visa_Booking_by_id,
  get_Visa_Booking_lists_with_pagination,
} from "../../../../api/VisaApi";
import VisaFilter from "./visa_filter/VisaFilter";
import { hasPrivilege } from "../../../../common_privilige_methods/Privilege_Methods";
import { CustomActionButtonWithTooltip } from "../../dashboard/dashboard_filter/DashboardFilter";
import { CommonHelpers } from "../../../../services/commonHelpers";

function Visa() {
  const navigate = useNavigate();
  const filter_data_store = useSelector(
    (state) => state.commonStore.notification_redirect
  );

  const baseRouteUrl = `/ecrs_portal/${LocalStorageServices.getUserRole()}/process_ecr`;

  const [data, setData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItemPerPage, setTotalItemPerPage] = useState(10);

  const [selectedId, setSelectedId] = useState("");
  const [searchFilter, setSearchFilter] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);
  const [cancelModal, setCancelModal] = useState(false);

  const [financeLevelModal, setfinanceLevelModal] = useState(false);
  const [actionModal, setActionModal] = useState(false);
  const [cfoLevelModal, setCfoLevelModal] = useState(false);

  const [commentModal, setcommentModal] = useState(false);
  const [invoiceDetailsModal, setInvoiceDetailsModal] = useState(false);

  //PASS THE MODULENAME,SUBMODULENAME AND THE PRIVILEGE NAME TO THE hasPrivilege FUNCTION
  const isPrivileges_Add = hasPrivilege("Process ECR", "Visa", "Add");
  const isPrivileges_View = hasPrivilege("Process ECR", "Visa", "View");
  const isPrivileges_Edit = hasPrivilege("Process ECR", "Visa", "Edit");
  const isPrivileges_Delete = hasPrivilege("Process ECR", "Visa", "Delete");
  const isPrivileges_Hold = hasPrivilege("Process ECR", "Visa", "Hold");
  const isPrivileges_Reject = hasPrivilege("Process ECR", "Visa", "Reject");
  const isPrivileges_Review = hasPrivilege("Process ECR", "Visa", "Review");
  const isPrivileges_Verify = hasPrivilege("Process ECR", "Visa", "Verify");
  const isPrivileges_Approve = hasPrivilege("Process ECR", "Visa", "Approve");

  useEffect(() => {
    if (
      !actionModal &&
      !cancelModal &&
      !deleteConfirmation &&
      !financeLevelModal
    ) {
      if (!filter_data_store?.filter_data) {
        getList(pageNumber, searchFilter);
      }
    }
  }, [
    pageNumber,
    totalItemPerPage,
    deleteConfirmation,
    cancelModal,
    actionModal,
    financeLevelModal,
    filter_data_store,
  ]); //deleteConfirmation for temprory page refresh handling

  const [isLoading, setIsLoading] = useState(true);
  const getList = (pageNumber, filterValue) => {
    const formData = new FormData();
    formData.append("page", pageNumber);
    formData.append("pageItem_count", totalItemPerPage);
    if (filterValue) {
      for (const key in filterValue) {
        formData.append(key, filterValue[key] ?? "");
      }
    }
    get_Visa_Booking_lists_with_pagination(formData)
      .then((response) => {
        if (response.data.code === 200) {
          setData(response?.data.data);
          setIsLoading(false);
          setTotalPages(response.data.pagination?.last_page);
        } else {
          setData([]);
          if (pageNumber > 1) {
            setPageNumber(pageNumber - 1);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const openLastInvoiceFn = (selected_item) => {
    const data = selected_item?.invoice;
    // Get last item safely
    const lastItem = data?.[data.length - 1];
    const lastFile = lastItem?.attachment;

    // Trigger download if file exists
    if (lastFile) {
      CommonHelpers.DownloadAssets(lastFile);
    } else {
      InfoToast("No Invoice found");
    }
  };

  const Columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "File Name",
      dataIndex: "visa_pnr",
      key: "visa_pnr",
    },
    {
      title: "Visa Type",
      dataIndex: "visa_type",
      key: "visa_type",
    },
    {
      title: "Issue Date",
      dataIndex: "issue_date",
      key: "issue_date",
    },
    {
      title: "Client",
      dataIndex: "client",
      key: "client",
    },
    {
      title: "Client Amount",
      dataIndex: "client_amount",
      key: "client_amount",
    },
    {
      title: "Supplier ",
      dataIndex: "supplier",
      key: "supplier",
    },
    {
      title: "Supplier Amount",
      dataIndex: "supplier_amount",
      key: "supplier_amount",
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      action: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          {isPrivileges_View && (
            <CustomActionButtonWithTooltip
              title="View"
              placement="top"
              onClick={() => {
                navigate(baseRouteUrl + `/${row.id}/view_visa`);
              }}
            >
              <PiEye className="packages_action_view" />
            </CustomActionButtonWithTooltip>
          )}
          
          {/* Staff Action handle */}
          {(row.ecr_status == 1 || row.ecr_status == 6) && isPrivileges_Edit ? (
            <>
              <CustomActionButtonWithTooltip
                title="Edit"
                placement="top"
                onClick={() => {
                  navigate(baseRouteUrl + `/${row.id}/update_visa`);
                }}
              >
                <BiEditAlt className="packages_action_edit" />
              </CustomActionButtonWithTooltip>

              {isPrivileges_Delete && (
                <CustomActionButtonWithTooltip
                  title="Delete"
                  placement="top"
                  onClick={() => {
                    setSelectedId(row.id);
                    setDeleteConfirmation(true);
                  }}
                >
                  <MdOutlineDeleteOutline className="packages_action_delete" />
                </CustomActionButtonWithTooltip>
              )}
            </>
          ) : (
            <></>
          )}

          {/* Finance Action handle */}
          {row.ecr_status === 3 || row.ecr_status === 6 ? (
            <>
              {isPrivileges_Hold && (
                <CustomActionButtonWithTooltip
                  title="Hold"
                  placement="top"
                  onClick={() => {
                    setActionModal(true);
                    setSelectedItem({ ...row, type: "Hold" });
                  }}
                >
                  <FaRegCirclePause className="flight_ticket_action_onhold" />
                </CustomActionButtonWithTooltip>
              )}
            </>
          ) : (
            <></>
          )}

          {row.ecr_status === 3 ||
          row.ecr_status === 7 ||
          row.ecr_status === 6 ? (
            <>
              {isPrivileges_Verify && (
                <CustomActionButtonWithTooltip
                  title="Verify"
                  placement="top"
                  onClick={() => {
                    setfinanceLevelModal(true);
                    setSelectedItem({ ...row, type: "Verify" });
                  }}
                >
                  <SiTicktick className="flight_ticket_action_verified" />
                </CustomActionButtonWithTooltip>
              )}
            </>
          ) : (
            <>
              {/* FOR HANDLE PACKAGE CANCELATION VERIFY BY FINANCE */}
              {row.ecr_status === 11 && isPrivileges_Verify && (
                <CustomActionButtonWithTooltip
                  title="Verify"
                  placement="top"
                  onClick={() => {
                    setfinanceLevelModal(true);
                    setSelectedItem({ ...row, type: "CancelVerified" });
                  }}
                >
                  <SiTicktick className="flight_ticket_action_verified" />
                </CustomActionButtonWithTooltip>
              )}
            </>
          )}
          {/*Manager Action handle  and also check submitted status  */}
          {row.ecr_status === 2 ? (
            <>
              {isPrivileges_Review && (
                <CustomActionButtonWithTooltip
                  title="Review"
                  placement="top"
                  onClick={() => {
                    setSelectedItem({ ...row, type: "Review" });
                    setActionModal(true);
                  }}
                >
                  <TiTickOutline className="flight_ticket_action_approve" />
                </CustomActionButtonWithTooltip>
              )}
              {isPrivileges_Reject && (
                <CustomActionButtonWithTooltip
                  title="Reject"
                  placement="top"
                  onClick={() => {
                    setSelectedItem({ ...row, type: "Reject" });
                    setActionModal(true);
                  }}
                >
                  <IoCloseCircleOutline className="flight_ticket_action_reject" />
                </CustomActionButtonWithTooltip>
              )}
            </>
          ) : row.ecr_status === 10 ? (
            <>
              {/* FOR HANDLE PACKAGE CANCELATION REVIEW BY MANAGER */}
              {isPrivileges_Review && (
                <CustomActionButtonWithTooltip
                  title="Review"
                  placement="top"
                  onClick={() => {
                    setSelectedItem({ ...row, type: "CancelReviewed" });
                    setActionModal(true);
                  }}
                >
                  <TiTickOutline className="flight_ticket_action_approve" />
                </CustomActionButtonWithTooltip>
              )}
            </>
          ) : (
            <></>
          )}

          {/* //CFO */}
          {row.ecr_status === 4 ? (
            <>
              {isPrivileges_Approve && (
                <CustomActionButtonWithTooltip
                  title="Approve"
                  placement="top"
                  onClick={() => {
                    setSelectedItem({ ...row, type: "Approve" });
                    setActionModal(true);
                  }}
                >
                  <TiTickOutline className="flight_ticket_action_approve" />
                </CustomActionButtonWithTooltip>
              )}

              {isPrivileges_Reject && (
                <CustomActionButtonWithTooltip
                  title="Reject"
                  placement="top"
                  onClick={() => {
                    setSelectedItem({ ...row, type: "CFOReject" });
                    setActionModal(true);
                  }}
                >
                  <IoCloseCircleOutline className="flight_ticket_action_reject" />
                </CustomActionButtonWithTooltip>
              )}
              {/* FOR HANDLE PACKAGE CANCELATION Approve BY CFO */}
            </>
          ) : (
            <>
              {row.ecr_status === 12 && (
                <>
                  {isPrivileges_Approve && (
                    <CustomActionButtonWithTooltip
                      title="Approve"
                      placement="top"
                      onClick={() => {
                        setSelectedItem({ ...row, type: "CancelApproved" });
                        setActionModal(true);
                      }}
                    >
                      <TiTickOutline className="flight_ticket_action_approve" />
                    </CustomActionButtonWithTooltip>
                  )}
                </>
              )}
            </>
          )}
          {true && (
            <CustomActionButtonWithTooltip
              onClick={() => {
                setSelectedItem({ ...row });
                setcommentModal(true);
              }}
            >
              <FaRegCommentAlt className="flight_ticket_action_comment" />
            </CustomActionButtonWithTooltip>
          )}
          {(row.ecr_status === 4 ||
            row.ecr_status === 5 ||
            row.ecr_status === 6 ||
            row.ecr_status === 7 ||
            row.ecr_status === 8) &&
            row?.invoice?.length !== 0 && (
              <CustomActionButtonWithTooltip
                title="Invoice"
                placement="top"
                onClick={() => {
                  setInvoiceDetailsModal(true);
                  setSelectedItem({ ...row });
                }}
              >
                <PiFilesLight className="flight_ticket_action_invoice" />
              </CustomActionButtonWithTooltip>
            )}

          {(row.ecr_status === 4 ||
            row.ecr_status === 5 ||
            row.ecr_status === 6 ||
            row.ecr_status === 7 ||
            row.ecr_status === 8) &&
            row?.invoice?.length !== 0 && (
              <CustomActionButtonWithTooltip
                title="Latest Invoice"
                placement="top"
                onClick={() => {
                  openLastInvoiceFn(row);
                }}
              >
                <LiaFileInvoiceSolid className="flight_ticket_action_invoice" />
              </CustomActionButtonWithTooltip>
            )}
        </div>
      ),
    },
  ];

  const handleDeleteModalClose = (is_close) => {
    setDeleteConfirmation(is_close);
    setSelectedId(null);
  };
  const datas = () => {
    const result =
      data &&
      data?.map((item, index) => {
        return {
          key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
          id: item.booking_id,
          visa_pnr: item.visa_pnr,
          visa_type: item.visa_type,
          issue_date: item.issue_date,
          supplier: item.supplier,
          supplier_amount: item.supplier_amount,
          service_fee: item.service_fee,
          client: item.client,
          client_amount: item.client_amount,
          status: item.status,
          invoice: item.invoice,
          ecr_status: item.status_id,
        };
      });
    return result;
  };

  const updatePagination = (pageNumber) => {
    setPageNumber(pageNumber);
  };
  const updateItemPageCount = (pageItemCount) => {
    setTotalItemPerPage(pageItemCount);
  };

  const searchfilter = (value) => {
    setSearchFilter(value);
    if (value) {
      getList(pageNumber, value);
    } else {
      getList(1, value);
      setPageNumber(1);
    }
  };

  const handleModalClose = (is_close) => {
    setCancelModal(is_close);
    setSelectedItem(null);
  };

  //MANAGER LELE MODAL CLOSE
  const handleActionModalClose = (is_close) => {
    setActionModal(is_close);
    setSelectedItem(null);
  };

  const handleFinanceLevelModalClose = (is_close) => {
    setfinanceLevelModal(is_close);
    setSelectedItem(null);
  };
  const handleCfoLevelModalClose = (is_close) => {
    setCfoLevelModal(is_close);
    setSelectedItem(null);
  };
  const handleCommentModalClose = (is_close) => {
    setcommentModal(is_close);
    setSelectedItem(null);
  };

  const handleInvoiceDetailsModalClose = (is_close) => {
    setInvoiceDetailsModal(is_close);
    setSelectedItem(null);
  };

  const deleteCab = () => {
    if (selectedId) {
      const payload = {
        booking_id: selectedId,
      };
      delete_Visa_Booking_by_id(payload)
        .then((response) => {
          if (response.code === 200) {
            handleDeleteModalClose(false);
            SuccessToast(response?.message);
          }
        })
        .catch((error) => {
          handleDeleteModalClose(false);
          ErrorToast(error?.data?.message);
        });
    }
  };

  return (
    <div className="packages_module_main_container">
      <p className="packages_title">Visa</p>
      <div>
        <div className="user_module_filter">
          <VisaFilter searchFilter={searchfilter} />
          {isPrivileges_Add && (
            <button
              className="packages_add_button"
              onClick={() => {
                navigate(baseRouteUrl + `/create_new_visa`);
              }}
            >
              Add New
            </button>
          )}
        </div>
        <div className="packages_table_main_container">
          <CustomTable columns={Columns} rows={datas()} loading={isLoading} />
        </div>
        <div>
          <CustomBottomPagination
            total_items_per_page={totalItemPerPage}
            total_page_count={totalPages}
            current_page={pageNumber}
            on_change_value={updatePagination}
            on_page_count_update={updateItemPageCount}
          />
        </div>
      </div>
      <CustomDeleteConfirmModal
        module_name={"Visa"}
        open_modal={deleteConfirmation}
        close_modal={handleDeleteModalClose}
        confirm_function={deleteCab}
      />

      <VisaReusableModal
        selected_item={selectedItem}
        open_modal={actionModal}
        modal_close={handleActionModalClose}
      />
      <VisaCommentModal
        open={commentModal}
        handleClose={handleCommentModalClose}
        booking_id={selectedItem?.id}
      />

      <VisaFinanceLevelModals
        selected_item={selectedItem}
        open_modal={financeLevelModal}
        modal_close={handleFinanceLevelModalClose}
      />
      {invoiceDetailsModal && (
        <VisaInvoiceDetailsModal
          selected_item={selectedItem}
          open_modal={invoiceDetailsModal}
          modal_close={handleInvoiceDetailsModalClose}
        />
      )}
    </div>
  );
}

export default Visa;
